import * as types from './actionTypes';

export const importKeywords = (keywordsText) => ({
  type: types.IMPORT_KEYWORDS,
  payload: keywordsText,
});

export const setRawImportedKeywords = (keywordsText) => ({
  type: types.SET_RAW_IMPORTED_KEYWORDS,
  payload: keywordsText,
});

export const addFolder = (folderName, parentId = null) => ({
  type: types.ADD_FOLDER,
  payload: {
    folderName,
    parentId,
  },
});

export const assignKeywordToFolder = (folderId, keywordItem) => ({
  type: types.ASSIGN_KEYWORD_TO_FOLDER,
  payload: {
    folderId,
    keywordItem,
  },
});

export const setKeywords = (keywords) => ({
  type: types.SET_KEYWORDS,
  payload: keywords,
});

// Keyword Status
export const toggleKeywordActive = (keywordId) => ({
  type: types.TOGGLE_KEYWORD_ACTIVE,
  payload: keywordId,
});

export const markKeywordDeleted = (keywordId) => ({
  type: types.MARK_KEYWORD_DELETED,
  payload: keywordId,
});

export const setKeywordVisibilityFilter = (filter) => ({
  type: types.SET_KEYWORD_VISIBILITY_FILTER,
  payload: filter,
});

// Filter Chip Actions
export const addFilterChip = (filterData) => ({
  type: types.ADD_FILTER_CHIP,
  payload: {
    id: `chip-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    ...filterData, // e.g., { type: 'text', label: 'Contains "foo"', params: { term: "foo" } }
                  // or { type: 'volume', label: 'Vol >= 1000', params: { operator: 'gte', value1: 1000 } }
  }
});

export const removeFilterChip = (filterId) => ({
  type: types.REMOVE_FILTER_CHIP,
  payload: filterId,
});

export const clearAllFilterChips = () => ({
  type: types.CLEAR_ALL_FILTER_CHIPS,
  // No payload needed
});


// Save/Restore State
export const restoreState = (newState) => ({
  type: types.RESTORE_STATE,
  payload: newState,
});

// Action creator for assigning multiple keywords
export const assignMultipleKeywordsToFolder = (folderId, keywordObjects) => ({
  type: types.ASSIGN_MULTIPLE_KEYWORDS_TO_FOLDER,
  payload: { folderId, keywordObjects }, // keywordObjects is an array of {id, text, data}
});

// Multi-select Actions
export const setSelectedKeywords = (keywordIdsArray) => ({
  type: types.SET_SELECTED_KEYWORDS,
  payload: keywordIdsArray,
});

export const toggleKeywordSelection = (keywordId) => ({
  type: types.TOGGLE_KEYWORD_SELECTION,
  payload: keywordId,
});

export const rangeSelectKeywords = (clickedKeywordId, allDisplayedKeywordIds) => ({
  type: types.RANGE_SELECT_KEYWORDS,
  payload: { clickedKeywordId, allDisplayedKeywordIds },
});

// N-gram Match Mode
export const setNGramMatchMode = (mode) => ({
  type: types.SET_NGRAM_MATCH_MODE,
  payload: mode, // 'wholeWord' or 'substring'
});

// Super-select Mode
export const toggleSuperSelectMode = () => ({
  type: types.TOGGLE_SUPER_SELECT_MODE,
});

// Folder Expansion
export const toggleFolderExpand = (folderId) => ({
  type: types.TOGGLE_FOLDER_EXPAND,
  payload: folderId,
});

// Reset App State
export const resetAppState = () => ({
  type: types.RESET_APP_STATE,
});

// To update UI-bound min/max values for specific column filters (like volumeFilter, kdFilter)
export const setColumnFilter = ({ columnName, min, max }) => ({
  type: types.SET_COLUMN_FILTER,
  payload: { columnName, min, max }
});
